<template>
  <v-card color="#efefef" class="mb-12">
    <v-card-title>
      Group de champ
      <v-spacer></v-spacer>
      <span class="body-2">{{(model.label)?'Label: ' + model.label:''}}</span>
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('up')">
        <v-icon>mdi-chevron-up</v-icon>
      </v-btn>
      <v-btn icon @click="$emit('down')">
        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-container v-if="!loading">
        <v-row>
          <template v-for="block in blocks">
            <v-col cols="12" :key="block.id">
              <block :block="block" :step="step" @change="getBlocks" />
            </v-col>
          </template>
          <v-col cols="4">
            <add-block :step="step" :parent-id="this.block.id" @add="getBlocks" />
          </v-col>
        </v-row>
      </v-container>

      <v-row align="center" justify="center" v-else>
        <v-progress-circular :indeterminate="true" />
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn fab dark x-small color="blue" @click="editPopup=true">
        <v-icon small>mdi-pencil</v-icon>
        <v-dialog v-model="editPopup" max-width="400">
          <v-card>
            <v-card-title>Option du groupe</v-card-title>
            <v-card-text>
              <v-row>
                <v-text-field v-model="model.label" label="Etiquette"></v-text-field>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn @click="save()">Sauver</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-btn>
      <v-btn fab dark x-small color="red" @click="deleteGroup()">
        <v-icon small>mdi-delete</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>
import AddBlock from "../AddBlock";
import Block from "../Block.vue";
import axios from "axios";
import { mapActions } from "vuex";

export default {
  name: "BlockFieldGroup",
  components: {
    AddBlock,
    Block
  },
  props: {
    block: {
      type: Object,
      required: true
    },
    step: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    blocks: [],
    loading: false,
    model: {
      label: null
    },
    editPopup: false
  }),
  mounted: function() {
    this.getBlocks();
    this.model = Object.assign({}, this.model, this.block.fieldObject);
  },
  methods: {
    ...mapActions("services", ["saveGroupOptions"]),
    async getBlocks() {
      this.loading = true;
      await axios
        .get(
          "service/" +
            this.step.services_id +
            "/step/" +
            this.step.id +
            "/block",
          {
            params: {
              parentId: this.block.id
            }
          }
        )
        .then(response => {
          this.blocks = response.data;
          this.loading = false;
        });
    },
    deleteGroup() {
      confirm("Etes-vous sûr de vouloire effacer ce groupe de champ ?") &&
        this.$emit("delete");
    },
    save() {
      this.saveGroupOptions({
        serviceId: this.step.services_id,
        stepId: this.step.id,
        blockId: this.block.id,
        model: this.model
      });
      this.editPopup = false;
    }
  }
};
</script>
